// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l1CaL","select":"styles_select__TvX1t"};